<template>
  <div class="groupActiveCodeStatisticsDetail-container">
    <el-dialog
      title="活码明细"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
      close-on-press-escape
      @close="close"
    >
      <div class="activeCode-name">
        活码名称: <span class="name"> {{ activeCodeName }}</span>
      </div>
      <div
        class="data-list-wrap"
        v-for="(item, index) in detailData"
        :key="index"
      >
        <div class="data-item-title">
          {{ `群聊${index + 1}：${item.chatName || "--"}` }}
        </div>
        <div class="data-item-content">
          <div class="data-item">
            进群人数：{{
              item.joinChatGroupNum != null ||
              item.joinChatGroupNum != undefined
                ? item.joinChatGroupNum
                : 0
            }}
          </div>
          <div class="data-item">
            退群人数：{{
              item.exitChatGroupNum != null ||
              item.exitChatGroupNum != undefined
                ? item.exitChatGroupNum
                : 0
            }}
          </div>
          <div class="data-item">
            当前群人数：{{
              item.currentGroupNum != null || item.currentGroupNum != undefined
                ? item.currentGroupNum
                : 0
            }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { statisticsDetailsApi } from "@/api/group/code.js";
export default {
  data() {
    return {
      /** 控制弹窗显示隐藏 */
      dialogVisible: false,
      /** 存储活码明细数据 */
      detailData: [],
      /** 单行的数据 */
      row: null,
      /** 群聊名称 */
      activeCodeName: "",
    };
  },
  methods: {
    /** 弹出初始化 */
    init(data) {
      this.row = data;
      this.dialogVisible = true;
      this.$nextTick(() => {
        /** 获取详情数据 */
        this.getData();
      });
    },

    /** 获取活码明细数sss据 */
    getData() {
      statisticsDetailsApi((this.row && this.row.id) || "").then((res) => {
        if (res && res.error && res.error.code == 200) {
          console.log("fgdgdgd", res.data);
          this.detailData = res.data;
          this.activeCodeName = (res.data && res.data[0].name) || "--";
        }
      });
    },

    /** 关闭弹窗触发 */
    close() {
      this.$emits("close");
    },
  },

  /** 生命周期 */
  created() {},
};
</script>
<style lang="scss" scoped>
.groupActiveCodeStatisticsDetail-container {
  .activeCode-name {
    font-size: 18px;
    margin-bottom: 20px;
    .name {
      color: #000;
       font-weight:600;
    }
  }
  .data-list-wrap {
    margin-bottom: 10px;
    .data-item-title {
      color: #000;
      font-size: 16px;
      font-weight:600;
      margin-bottom: 10px;
    }
    .data-item-content {
      display: flex;
      align-items: center;
      .data-item {
        margin-right: 20px;
      }
    }
  }
  /deep/.el-dialog__body{
    padding-top:10px;
  }
}
</style>
